import { environment } from 'src/environments/environment';

export const InstitutionNameOverrideMap: Map<number, string> =
  environment.production ?
    new Map([
      [7, 'Columbia'],
      [8, 'Kansas City'],
      [9, 'Rolla'],
      [10, 'St. Louis'],
    ])
  : new Map([
      [7, 'Columbia'],
      [8, 'Kansas City'],
      [9, 'Rolla'],
      [10, 'St. Louis'],
      [15, 'Columbia'],
      [16, 'Kansas City'],
      [17, 'Rolla'],
      [18, 'St. Louis'],
    ]);

export const InstitutionAbbrNavOverrideMap: Map<number, string> =
  environment.production ?
    new Map([
      [7, 'missouri'],
      [8, 'umkc'],
      [9, 'mst'],
      [10, 'umsl'],
    ])
  : new Map([
      [7, 'missouri'],
      [8, 'umkc'],
      [9, 'mst'],
      [10, 'umsl'],
      [15, 'missouri'],
      [16, 'umkc'],
      [17, 'mst'],
      [18, 'umsl'],
    ]);

export const SystemAbbrNavOverrideMap: Map<number, string> =
  environment.production ?
    new Map([[7, 'umsystem']])
  : new Map([
      [7, 'umsystem'],
      [15, 'umsystem'],
    ]);
